// src/tenant/TenantProvider.jsx
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { fetchTenantsFlexible } from "./tenantApi";
import { readTenantId, writeTenantId, getTenantFromSubdomain } from "./tenantStorage";

const TenantCtx = createContext(null);

export function TenantProvider({ children, subdomainMap = {} }) {
  const [tenantId, setTenantId] = useState(null);
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  // 1) resolve tenant inicial (ordem: querystring -> localStorage -> subdomínio -> primeiro da lista)
useEffect(() => {
  let canceled = false;

  // evita loop: só refaz o fetch se ainda não tiver carregado
  if (tenants.length === 0 && !loading) {
    setLoading(true);
  }

  (async () => {
    try {
      const list = await fetchTenantsFlexible();
      if (canceled) return;
      setTenants(list);

      const usp = new URLSearchParams(window.location.search);
      const tFromQuery = usp.get("t");
      const tFromStorage = readTenantId();
      const tFromSub = getTenantFromSubdomain(subdomainMap);
      const firstFromList = list?.[0]?._id || list?.[0]?.id || null;

      const preferred =
        tFromQuery ||
        tFromStorage ||
        tFromSub ||
        firstFromList ||
        null;

      setTenantId(preferred);
      writeTenantId(preferred);
    } catch (e) {
      if (!canceled) setErr(e);
    } finally {
      if (!canceled) setLoading(false);
    }
  })();

  return () => {
    canceled = true;
  };
  // roda só 1x ao montar
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);


  const value = useMemo(() => ({
    tenantId,
    setTenantId: (id) => {
      setTenantId(id);
      writeTenantId(id);
    },
    tenants,
    loading,
    error: err,
  }), [tenantId, tenants, loading, err]);

  return <TenantCtx.Provider value={value}>{children}</TenantCtx.Provider>;
}

export function useTenant() {
  const ctx = useContext(TenantCtx);
  if (!ctx) throw new Error("useTenant must be used inside <TenantProvider/>");
  return ctx;
}
